import type { FC } from 'react';
import { StringBuilderBufferWrapper } from './StringBuilderBuffer.styled';

interface StringBuilderBufferProps { }

const StringBuilderBuffer: FC<StringBuilderBufferProps> = () => (
   <StringBuilderBufferWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">String Builder, Buffer &amp; Tokenizer</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <h4 className="text-align-justify">1. <strong>String Builder </strong></h4>
         <ul className="text-align-justify">
            <li>StringBuilder objects are String objects where we can modify the value of the object. Hence to <strong>create a mutable (modifiable) string object, </strong>we use the Java StringBuilder class.</li>
            <li>StringBuilder is <strong>not thread-safe </strong>or, in other words, <strong>not synchronized</strong>. One should prefer using StringBuffer if synchronization is mandatory.</li>
            <li>The class is designed for use as a drop-in replacement for StringBuffer in places where the String Buffer used by a single thread.</li>
            <li><strong>Class Hierarchy :  </strong>
               java.lang.Object 
               &nbsp;<span className="fa fa-angle-right"></span>&nbsp;
               java.lang
               &nbsp;<span className="fa fa-angle-right"></span>&nbsp;
               Class StringBuilder
            </li>
            <br/>
            <li>Constructors of StringBuilder Class :
               <ul>
                  <li><strong>StringBuilder() </strong>constructor constructs a string builder with no characters in it and an initial capacity of 16 characters.</li>
                  <li><strong>StringBuilder(int capacity) </strong>constructor constructs a string builder with no characters in it and an initial capacity specified by the capacity argument.</li>
                  <li><strong>StringBuilder(CharSequence seq) </strong>constructor constructs a string builder that contains the same characters as the specified CharSequence.</li>
                  <li><strong>StringBuilder(String str) </strong>constructor constructs a string builder initialized to the specified string’s contents. Also, the initial capacity of the string builder is 16 plus the length of the string argument.</li>
               </ul>
            </li>
            <br/>
            <li>Some methods of StringBuilder class :
               <ul>
                  <li><strong>append () </strong>concatenates the given argument(string representation) to the end of the invoking StringBuilder object.</li>
                  <li><strong>insert() </strong>inserts the given argument(string representation) into the invoking StringBuilder object at the given position.</li>
                  <li><strong>replace()</strong> replaces the string from a specified start index to the end index.</li>
                  <li><strong>reverse() </strong>reverses the characters within a StringBuilder object.</li>
                  <li><strong>delete() </strong>deletes the string from the specified beginIndex to the endIndex.</li>
                  <li><strong>capacity() </strong>returns the current capacity of the StringBuilder object. </li>
               </ul>
            </li>
         </ul>
         <br />
         <h4 className="text-align-justify">2. <strong>String Buffer </strong></h4>
         <ul className="text-align-justify">
            <li>StringBuffer<strong> </strong>is a peer class of String that <strong>creates mutable (modifiable) string</strong>, i.e., it represents growable and writable character sequences.</li>
            <li>One may insert characters and substrings in the middle or append them to the end in StringBuffer. It will automatically grow to make room for such additions and often pre-allocate more characters than we need to allow room for growth.</li>
            <li>StringBuffer is thread-safe; most of its methods are synchronized. So multiple threads cannot access or use the StringBuffer object at the same time.</li>
            <br/>
            <li>Constructors of StringBuffer Class :
               <ul>
                  <li><strong>StringBuffer() </strong>constructor reserves room for 16 characters without reallocation.</li>
                  <li><strong>StringBuffer(int size) </strong>constructor accepts an integer argument that explicitly sets the buffer’s size.</li>
                  <li><strong>StringBuffer(String str) </strong>constructor accepts a String argument and sets the StringBuffer object’s initial contents. Also, it reserves room for 16 more characters without reallocation.</li>
               </ul>
            </li>
            <br/>
            <li>Some methods of StringBuffer class :
               <ul>
                  <li><strong>length() </strong>returns the StringBuffer object’s length.</li>
                  <li><strong>capacity() </strong>returns the capacity of the StringBuffer object.</li>
                  <li><strong>append( ) </strong>adds text at the end of the existing text.</li>
                  <li><strong>insert( ) </strong>inserts text at the specified index position.</li>
                  <li><strong>reverse( ) </strong>reverses the characters within a StringBuffer object. It will return the object with reverse values.</li>
                  <li><strong>ensureCapacity( ) </strong>increases the capacity of a StringBuffer object and ensures that the capacity is equal to the given minimum.</li>
               </ul>
            </li>
         </ul>
         <br />
         <h4 className="text-align-justify">3. <strong>String Tokenizer </strong></h4>
         <ul className="text-align-justify">
            <li>An application can <strong>break a string into tokens</strong> with the help of StringTokenizer class. It is a simple way to break a string.</li>
            <li>It does not have the facility to differentiate between numbers, quoted strings, identifiers, etc.</li>
            <li>A current position is maintained internally by the StringTokenizer object within the string to be tokenized.</li>
            <br/>
            <li>Constructors of StringTokenizer Class :
               <ul>
                  <li><strong>StringTokenizer(String str) </strong>accepts a string that needs to be tokenized. The default delimiters used are new line, space, tab, carriage return, and form feed.</li>
                  <li><strong>StringTokenizer(String str, String delim) </strong>accepts a string and a set of delimiters used to tokenize the given string.</li>
                  <li><strong>StringTokenizer(String str, String delim, boolean flag)</strong> accepts a string, set of delimiters, and a flag. If the flag is true, delimiter characters are considered to be tokens. If the flag is false, delimiter characters serve to separate tokens.</li>
               </ul>
            </li>
            <br/>
            <li>Some methods of StringTokenizer Class :
               <ul>
                  <li><strong>hasMoreTokens() </strong>checks if there are more tokens available.</li>
                  <li><strong>nextToken() </strong>returns the next token from the StringTokenizer object.</li>
                  <li><strong>nextToken(String delim) </strong>returns the next token based on the delimiter.</li>
                  <li><strong>hasMoreElements() </strong>is same as hasMoreTokens() method.</li>
                  <li><strong>nextElement() </strong>is same as nextToken() but its return type is Object.</li>
                  <li><strong>countTokens() </strong>returns the total number of tokens.</li>
               </ul>
            </li>
         </ul>
      </div>
   </StringBuilderBufferWrapper>
);

export default StringBuilderBuffer;
